// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-wrapper {
  width: 100%;
  min-height: calc(100dvh - 248px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 50px;
}
.reset-password-content {
  max-width: 450px;
  width: 100%;
  margin: 0 auto;
  padding: 50px 0;
}
.reset-password-content h1 {
  text-align: center;
  margin-bottom: 30px;
}
.formInputContainer {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.hide {
  display: none !important;
}
@media only screen and (max-width: 991px) {
  .reset-wrapper {
    min-height: calc(100dvh - 228px);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/forgotPassword/ForgotPassword.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,gCAAgC;EAClC;AACF","sourcesContent":[".reset-wrapper {\n  width: 100%;\n  min-height: calc(100dvh - 248px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 50px;\n}\n.reset-password-content {\n  max-width: 450px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 50px 0;\n}\n.reset-password-content h1 {\n  text-align: center;\n  margin-bottom: 30px;\n}\n.formInputContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.hide {\n  display: none !important;\n}\n@media only screen and (max-width: 991px) {\n  .reset-wrapper {\n    min-height: calc(100dvh - 228px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
